"use client";

import React from "react";
import Navbars from "./Navbar";
import Footer from "./Footer";
import MyState from "@/context/myState";
import { Provider } from "react-redux";
import store from "@/redux/store.js";
import WhatsAppChat from "./WhatsappContact";
import ScrollTop from "./ScrollTop";
import TopAlert from "./TopAlert";
import { usePathname } from "next/navigation";
import AdminLayout from "@/components/dashboard/adminDashboard/AdminLayout.jsx";
import BlogManagerLayout from "@/components/dashboard/blogManagerDashboard/BlogManagerLayout.jsx";
import PropertyManagerLayout from "../dashboard/propertyManager/PropertyManagerLayout";
import Layout from "../dashboard/userDashnoard/Layout";


export function Wrapper({ children }) {
  const pathname = usePathname();
  const isUser = pathname.startsWith("/user");
  const isApp = pathname.startsWith("/post-property-app");
  const isPackers = pathname.startsWith("/packers");
  const isInventory = pathname.startsWith("/inventory");
  const isSearch = pathname.startsWith("/app-search");


  const isAllProperties = pathname.startsWith("/all-properties-app");




  return (
      <>
       { !isApp && !isPackers&& !isInventory&&!isAllProperties &&!isSearch&&<div className="min-h-screen flex flex-col">
          <Navbars />
           {isUser ? <Layout>{children}</Layout> : children}
          <Footer />
           <WhatsAppChat />
        </div>}

        {isApp&&<div className="min-h-screen flex flex-col">
          {children}
          </div>}

          {isPackers&&<div className="min-h-screen flex flex-col">
          {children}
          </div>}
          {isInventory&&<div className="min-h-screen flex flex-col">
          {children}
          </div>}

          {isAllProperties&&<div className="min-h-screen flex flex-col">
          {children}
          </div>}

          {isSearch&&<div className="min-h-screen flex flex-col">
          {children}
          </div>}
        <ScrollTop />
       
      </>
  );
}


export default function conditionalWrapper({ children }) {
  const pathname = usePathname();
  const isAdmin = pathname.startsWith("/admin");
  const isBlogDashboard = pathname.startsWith("/blog-dashboard");
  const ispropertDashboard = pathname.startsWith("/property-dashboard");
 



  return (
    <Provider store={store}>
      <MyState>
        {isAdmin ? (
          <AdminLayout>{children}</AdminLayout>
        ) : isBlogDashboard ? (
          <BlogManagerLayout>{children}</BlogManagerLayout>
        ): ispropertDashboard ? (
          <PropertyManagerLayout>{children}</PropertyManagerLayout>
        ) : (
          <Wrapper>{children}</Wrapper>
        )}
        <TopAlert />
      </MyState>
    </Provider>
  );
}